import { Box, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface LoanHeaderDetailProps {
    label: string;
    text: ReactNode; // Allow JSX elements as text
    align?: any;
    link?: string;
}

const LoanHeaderDetail = ({
    label,
    text,
    align = "left",
    link,
}: LoanHeaderDetailProps) => {
    return (
        <Box textAlign={align}>
            <Text
                fontSize="14px"
                fontWeight="500"
                lineHeight="24px"
                color="gray.200"
            >
                {label}
            </Text>
            {text ? (
                <>
                    {typeof text === "string" ? (
                        <>
                            {link ? (
                                <Text
                                    as={Link}
                                    to={link}
                                    fontWeight={500}
                                    color="secondary"
                                    fontSize="16px"
                                >
                                    {text}
                                </Text>
                            ) : (
                                <Text
                                    fontWeight={500}
                                    color="secondary"
                                    fontSize="16px"
                                >
                                    {text}
                                </Text>
                            )}
                        </>
                    ) : (
                        <>{text}</>
                    )}
                </>
            ) : (
                <Text fontWeight={500} color="secondary" fontSize="16px">
                    Not Provided
                </Text>
            )}
        </Box>
    );
};

export default LoanHeaderDetail;
